module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-container"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "inline-block",
      "width": "728px",
      "height": "90px"
    },
    attrs: {
      "data-ad-client": "ca-pub-9675050026743432",
      "data-ad-slot": "8575911567"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f93ab0a!./src/components/ads-container/ads-container.html
// module id = 111
// module chunks = 2